import React from "react";

const getSectionDescription = (title) => {
    const value = String(title || "").toLowerCase();

    if (value.includes("transaction")) return "Basic transaction and registration details";
    if (value.includes("tare") || value.includes("weight")) return "Enter weight details and calculated totals";
    if (value.includes("delivery") || value.includes("address")) return "Delivery and contact information";
    if (value.includes("spotter") || value.includes("image")) return "Upload and review captured images";
    if (value.includes("product")) return "Product information and configuration";
    if (value.includes("customer")) return "Customer information and account details";
    if (value.includes("vehicle") || value.includes("truck")) return "Vehicle information and configuration";
    if (value.includes("site")) return "Site information and configuration";
    if (value.includes("user")) return "User access and profile details";
    if (value.includes("other") || value.includes("additional")) return "Additional information";
    return "Review and update these details";
};

function ExpansionPanel({ title, description, expanded, onToggle, children }) {
    const panelId = `form-section-${String(title || "details").replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`;

    return (
        <section className={`wm-form-panel${expanded ? " wm-form-panel--expanded" : ""}`}>
            <button
                id={`${panelId}-header`}
                className="wm-form-panel__header"
                type="button"
                onClick={onToggle}
                aria-expanded={expanded}
                aria-controls={panelId}
            >
                <span className="wm-form-panel__heading">
                    <strong>{title}</strong>
                    <small>{description || getSectionDescription(title)}</small>
                </span>
                <i className={`fa-solid fa-chevron-${expanded ? "up" : "down"}`} aria-hidden="true" />
            </button>
            {expanded && (
                <div id={panelId} className="wm-form-panel__content" role="region" aria-labelledby={`${panelId}-header`}>
                    {children}
                </div>
            )}
        </section>
    );
}

export default ExpansionPanel;
